import {AddressChangeRequest, ValidChangeAddress} from 'Agent/Policies/models/ServiceRequest/AddressChangeRequest';
import {
  DirectBillingScheduleChangeRequest,
  ValidChangeDirectBillingSchedule,
} from 'Agent/Policies/models/ServiceRequest/DirectBillingScheduleChangeRequest';
import {
  PayrollAllotmentChangeRequest,
  ValidChangePayrollAllotment,
} from 'Agent/Policies/models/ServiceRequest/PayrollAllotmentChangeRequest';

export type ChangeRequest = AddressChangeRequest | DirectBillingScheduleChangeRequest | PayrollAllotmentChangeRequest;

export type ValidChangeRequest = ValidChangeAddress | ValidChangeDirectBillingSchedule | ValidChangePayrollAllotment;

export const isValidChangeRequest = (changeRequest: ChangeRequest): changeRequest is ValidChangeRequest =>
  changeRequest.key === 'ValidChangeAddress' ||
  changeRequest.key === 'ValidChangeDirectBillingSchedule' ||
  changeRequest.key === 'ValidChangePayrollAllotment';

export type IncompleteChangeRequestOptions<TReturn> = {
  AddressChangeRequest?: (address: AddressChangeRequest) => TReturn;
  DirectBillingChangeRequest?: (directBillingRequest: DirectBillingScheduleChangeRequest) => TReturn;
  PayrollAllotmentChangeRequest?: (payrollChangeRequest: PayrollAllotmentChangeRequest) => TReturn;
  default: (changeRequest: ChangeRequest) => TReturn;
};

export type CompleteChangeRequestOptions<TReturn> = {
  AddressChangeRequest: (address: AddressChangeRequest) => TReturn;
  DirectBillingChangeRequest: (directBillingRequest: DirectBillingScheduleChangeRequest) => TReturn;
  PayrollAllotmentChangeRequest: (payrollChangeRequest: PayrollAllotmentChangeRequest) => TReturn;
  default?: (changeRequest: ChangeRequest) => TReturn;
};

export type ChangeRequestOptions<TReturn> =
  | IncompleteChangeRequestOptions<TReturn>
  | CompleteChangeRequestOptions<TReturn>;

export const matchChangeRequest = <TReturn>(changeRequest: ChangeRequest, options: ChangeRequestOptions<TReturn>) => {
  switch (changeRequest.key) {
    case 'ValidChangePayrollAllotment':
    case 'InvalidChangePayrollAllotment':
      return options.PayrollAllotmentChangeRequest
        ? options.PayrollAllotmentChangeRequest(changeRequest)
        : options.default!(changeRequest);
    case 'ValidChangeAddress':
    case 'InvalidChangeAddress':
      return options.AddressChangeRequest
        ? options.AddressChangeRequest(changeRequest)
        : options.default!(changeRequest);
    case 'InvalidChangeDirectBillingSchedule':
    case 'ValidChangeDirectBillingSchedule':
      return options.DirectBillingChangeRequest
        ? options.DirectBillingChangeRequest(changeRequest)
        : options.default!(changeRequest);
  }
};
